import React, { useMemo } from "react";
import ProductCard from "../../../common/productCard";
import "./style.css";

// ⚡ OPTIMIZATION: React.memo prevents unnecessary re-renders when props don't change
const FeaturedCategoris = React.memo(({ category }) => {
  const path = category.pageUrl.replace("fc/", "");

  // ⚡ OPTIMIZATION: useMemo to avoid recalculating on every render
  const processedProducts = useMemo(() => {
    if (!category?.products?.length) return [];
    
    return category.products.map((product) => {
      // Calculate final price from variations if available
      if (product?.variations?.length > 0) {
        const finalPrice = Math.min(...product.variations.map(v => v.finalPrice));
        return { ...product, finalPrice };
      }
      return product;
    });
  }, [category?.products]);

  return (
    <div className="home_blow_out_sales">
      <div className="home_blow_out_sale_head_row">
        {/* <Link to={path}> */}
          <h1>{category?.name}</h1>
        {/* </Link> */}
        {/* <Link to={`/collection${path}?fcId=${category?.fcId}`}> */}
          {/* <p>View More</p> */}
        {/* </Link> */}
      </div>

      <div className="home_blow_out_sales_product_row">
        {processedProducts.length > 0 ? (
          processedProducts.map((product, index) => (
            <ProductCard 
              key={product._id || product.sku || index} 
              product={product} 
              isFromFeaturedCategory={true}
              isSelectable={product?.moq === 1}
            />
          ))
        ) : (
          <p>No products available in this category</p>
        )}
      </div>
    </div>
  );
});

// ⚡ Display name for React DevTools
FeaturedCategoris.displayName = 'FeaturedCategoris';

export default FeaturedCategoris;
